// Die-cut shape clipping for round/oval labels. Label snapshots are always
// rectangular (white canvas); for round/oval die-cuts we clip the bitmap to an
// ellipse so the corners go transparent — making preview tiles and exported
// PDFs show the real label outline instead of a bounding rectangle.

/** Clip a label PNG dataURL to its shape. round/oval → ellipse filling the bbox
 *  (a circle when the bbox is square); rect/undefined → returned unchanged. */
export function clipImageToShape(dataUrl: string, shape?: string): Promise<string> {
  if (shape !== 'round' && shape !== 'oval') return Promise.resolve(dataUrl)
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => {
      const c = document.createElement('canvas')
      c.width = img.width
      c.height = img.height
      const ctx = c.getContext('2d')
      if (!ctx) { resolve(dataUrl); return }
      ctx.beginPath()
      ctx.ellipse(c.width / 2, c.height / 2, c.width / 2, c.height / 2, 0, 0, Math.PI * 2)
      ctx.closePath()
      ctx.clip()
      ctx.drawImage(img, 0, 0)
      resolve(c.toDataURL('image/png'))
    }
    img.onerror = () => resolve(dataUrl)
    img.src = dataUrl
  })
}

/** Clip many images to one shape (no-op for rect/undefined). */
export function clipImagesToShape(images: string[], shape?: string): Promise<string[]> {
  if (shape !== 'round' && shape !== 'oval') return Promise.resolve(images)
  return Promise.all(images.map((im) => (im ? clipImageToShape(im, shape) : Promise.resolve(im))))
}

/** CSS border-radius that renders a round/oval die-cut in a preview tile. */
export function shapeBorderRadius(shape?: string): string {
  return shape === 'round' || shape === 'oval' ? '50%' : ''
}
